module.exports = __webpack_public_path__ + "static/media/CLA_CSV_3.4383f4ea.svg";